import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, MessageCircle, ChevronRight } from 'lucide-react';
import ContactForm from '../components/ContactForm';

const ContactoPage = () => {
  return (
    <div className="industrial-bg" data-testid="contacto-page">
      {/* Hero */}
      <section className="bg-[#1A365D] py-16">
        <div className="section-container">
          <nav className="text-sm text-gray-400 mb-4" aria-label="Breadcrumb">
            <ol className="flex items-center gap-2">
              <li><Link to="/" className="hover:text-white">Inicio</Link></li>
              <li><ChevronRight className="w-4 h-4" /></li>
              <li className="text-white">Contacto</li>
            </ol>
          </nav>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-white uppercase mb-4">
            Contacta con Nosotros
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl">
            ¿Necesitas yesos, pladur o aislamientos en Motril? Llámanos o envíanos un mensaje. 
            Te atendemos de forma personalizada.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="section-container">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div>
              <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#1A365D] uppercase mb-8">
                Información de Contacto
              </h2>

              {/* Contact Cards */}
              <div className="space-y-6 mb-10">
                {/* Teléfonos */}
                <div className="bg-white p-6 rounded-sm border border-gray-200 card-hover">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#3182CE]/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <Phone className="w-6 h-6 text-[#3182CE]" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-[#1A365D] mb-2">Teléfonos</h3>
                      <a 
                        href="tel:858130213" 
                        className="block text-lg text-[#4A5568] hover:text-[#3182CE] transition-colors mb-1"
                        data-testid="contact-phone-1"
                      >
                        858 130 213
                      </a>
                      <a 
                        href="tel:622339574" 
                        className="block text-[#4A5568] hover:text-[#3182CE] transition-colors"
                        data-testid="contact-phone-2"
                      >
                        622 339 574 <span className="text-sm text-[#64748B]">(Asesoramiento Técnico y Comercial)</span>
                      </a>
                    </div>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="bg-white p-6 rounded-sm border border-gray-200 card-hover">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#25D366]/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <MessageCircle className="w-6 h-6 text-[#25D366]" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-[#1A365D] mb-2">WhatsApp</h3>
                      <a 
                        href="https://wa.me/34622339574?text=Hola,%20me%20gustaría%20solicitar%20información%20sobre%20sus%20productos."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-[#25D366] font-medium hover:underline"
                        data-testid="contact-whatsapp"
                      >
                        Enviar mensaje por WhatsApp
                        <ChevronRight className="w-4 h-4" />
                      </a>
                      <p className="text-sm text-[#64748B] mt-1">
                        Asesoramiento técnico y comercial directo
                      </p>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="bg-white p-6 rounded-sm border border-gray-200 card-hover">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#3182CE]/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <Mail className="w-6 h-6 text-[#3182CE]" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-[#1A365D] mb-2">Email</h3>
                      <a 
                        href="mailto:fornesehijos@gmail.com" 
                        className="text-[#4A5568] hover:text-[#3182CE] transition-colors"
                        data-testid="contact-email"
                      >
                        fornesehijos@gmail.com
                      </a>
                    </div>
                  </div>
                </div>

                {/* Dirección */}
                <div className="bg-white p-6 rounded-sm border border-gray-200 card-hover">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#3182CE]/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-6 h-6 text-[#3182CE]" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-[#1A365D] mb-2">Dirección</h3>
                      <p className="text-[#4A5568] mb-2">
                        Polígono Alborán, C. Mar Cantábrico, Nave 3<br />
                        18613 Motril, Granada
                      </p>
                      <a 
                        href="https://www.google.com/maps/place/Fornes+e+Hijos/@36.7275346,-3.5402629,17z"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-[#3182CE] font-medium hover:underline"
                        data-testid="contact-directions"
                      >
                        Ver en Google Maps
                        <ChevronRight className="w-4 h-4" />
                      </a>
                    </div>
                  </div>
                </div>

                {/* Horario */}
                <div className="bg-white p-6 rounded-sm border border-gray-200 card-hover">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-[#3182CE]/10 rounded-sm flex items-center justify-center flex-shrink-0">
                      <Clock className="w-6 h-6 text-[#3182CE]" />
                    </div>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-[#1A365D] mb-2">Horario</h3>
                      <div className="text-[#4A5568]">
                        <p className="mb-1">
                          <span className="font-medium">Lunes a Viernes:</span><br />
                          07:30 - 13:30 y 15:30 - 18:00
                        </p>
                        <p>
                          <span className="font-medium">Sábados:</span><br />
                          Solo bajo pedido
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="bg-white p-8 rounded-sm border border-gray-200 shadow-sm">
                <h2 className="font-heading text-2xl font-bold text-[#1A365D] uppercase mb-2">
                  Envíanos un Mensaje
                </h2>
                <p className="text-[#64748B] mb-8">
                  Rellena el formulario y te contactaremos lo antes posible.
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-white">
        <div className="section-container">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#1A365D] uppercase text-center mb-8">
            Cómo Llegar
          </h2>
          <div className="map-container h-96" data-testid="contacto-google-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.8147!2d-3.5402629!3d36.7275346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd719b848677d48f%3A0x79efd0ad4173b1c3!2sFornes%20e%20Hijos!5e0!3m2!1ses!2ses!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de Fornes e Hijos en Motril"
            ></iframe>
          </div>
          <div className="text-center mt-8">
            <a
              href="https://www.google.com/maps/dir//Fornes+e+Hijos,+Pol%C3%ADgono+Albor%C3%A1n,+C.+Mar+Cant%C3%A1brico,+Nave+3,+18613+Motril,+Granada/@36.7275346,-3.5402629,17z"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2"
              data-testid="contacto-cta-directions"
            >
              <MapPin className="w-5 h-5" />
              Obtener Indicaciones
            </a>
          </div>
        </div>
      </section>

      {/* Quick CTA */}
      <section className="py-12 bg-[#1A365D]">
        <div className="section-container">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="font-heading text-2xl font-bold text-white uppercase">
                ¿Prefieres llamarnos directamente?
              </h2>
              <p className="text-gray-300">Atendemos tu llamada de lunes a viernes.</p>
            </div>
            <a
              href="tel:858130213"
              className="inline-flex items-center gap-2 bg-white text-[#1A365D] font-semibold px-8 py-4 rounded-sm hover:bg-gray-100 transition-colors text-lg"
              data-testid="contacto-final-cta"
            >
              <Phone className="w-6 h-6" />
              858 130 213
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactoPage;
